import {
  // ADD
  ADD_RETURN_REFUND_REQUEST,
  ADD_RETURN_REFUND_SUCCESS,
  ADD_RETURN_REFUND_FAIL,
  // HISTORY - PRODUCT
  GET_PRODUCT_RETURN_REFUND_HISTORY_REQUEST,
  GET_PRODUCT_RETURN_REFUND_HISTORY_SUCCESS,
  GET_PRODUCT_RETURN_REFUND_HISTORY_FAIL,
  // HISTORY - COMPONENT
  GET_COMPONENT_RETURN_REFUND_HISTORY_REQUEST,
  GET_COMPONENT_RETURN_REFUND_HISTORY_SUCCESS,
  GET_COMPONENT_RETURN_REFUND_HISTORY_FAIL,
  // UPDATE
  UPDATE_RETURN_REFUND_REQUEST,
  UPDATE_RETURN_REFUND_SUCCESS,
  UPDATE_RETURN_REFUND_FAIL,
  // DELETE - PRODUCT
  DELETE_PRODUCT_RETURN_REFUND_REQUEST,
  DELETE_PRODUCT_RETURN_REFUND_SUCCESS,
  DELETE_PRODUCT_RETURN_REFUND_FAIL,
  // DELETE - COMPONENT
  DELETE_COMPONENT_RETURN_REFUND_REQUEST,
  DELETE_COMPONENT_RETURN_REFUND_SUCCESS,
  DELETE_COMPONENT_RETURN_REFUND_FAIL,
} from "../constants/productConstants";


// ---- Add Return/Refund Reducer ----
export const returnRefundAddReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_RETURN_REFUND_REQUEST:
      return { loading: true };
    case ADD_RETURN_REFUND_SUCCESS:
      return { loading: false, success: true, ...action.payload };
    case ADD_RETURN_REFUND_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// ---- Product Return/Refund History ----
export const returnRefundHistoryReducer = (state = { returnRefundHistory: [] }, action) => {
  switch (action.type) {
    case GET_PRODUCT_RETURN_REFUND_HISTORY_REQUEST:
    case GET_COMPONENT_RETURN_REFUND_HISTORY_REQUEST:
      return { ...state, loading: true, error: null, message: null };
    case GET_PRODUCT_RETURN_REFUND_HISTORY_SUCCESS:
    case GET_COMPONENT_RETURN_REFUND_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        returnRefundHistory: action.payload.returnRefundHistory || [],
        product: action.payload.product,
        component: action.payload.component,
        message: action.payload.message || null,
        error: null,
      };
    case GET_PRODUCT_RETURN_REFUND_HISTORY_FAIL:
    case GET_COMPONENT_RETURN_REFUND_HISTORY_FAIL:
      return { ...state, loading: false, error: action.payload };
    // Allow reusing this reducer for update and delete as well if desired
    case UPDATE_RETURN_REFUND_REQUEST:
    case DELETE_PRODUCT_RETURN_REFUND_REQUEST:
    case DELETE_COMPONENT_RETURN_REFUND_REQUEST:
      return { ...state, loading: true, error: null, message: null };
    case UPDATE_RETURN_REFUND_SUCCESS:
    case DELETE_PRODUCT_RETURN_REFUND_SUCCESS:
    case DELETE_COMPONENT_RETURN_REFUND_SUCCESS:
      return {
        ...state,
        loading: false,
        returnRefundHistory: action.payload.returnRefundHistory || state.returnRefundHistory,
        message: action.payload.message || null,
        error: null,
      };
    case UPDATE_RETURN_REFUND_FAIL:
    case DELETE_PRODUCT_RETURN_REFUND_FAIL:
    case DELETE_COMPONENT_RETURN_REFUND_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
